import axiosInstance from '../../utils/axiosInstance';

// ─── CATEGORIES ───────────────────────────────────────────────────────────────

export const getCategories = () => axiosInstance.get('/videos/categories/list');

export const createCategory = (formData) =>
  axiosInstance.post('/videos/categories', formData);

export const updateCategory = (id, formData) =>
  axiosInstance.put(`/videos/categories/${id}`, formData);

export const deleteCategory = (id) =>
  axiosInstance.delete(`/videos/categories/${id}`);

// ─── VIDEOS ───────────────────────────────────────────────────────────────────

export const getVideos = (params = {}) =>
  axiosInstance.get('/videos', { params });

export const getVideo = (id) => axiosInstance.get(`/videos/${id}`);

export const createVideo = (data) => axiosInstance.post('/videos', data);

export const updateVideo = (id, data) => axiosInstance.put(`/videos/${id}`, data);

export const toggleLock = (id, isLocked, unlockCost) =>
  axiosInstance.put(`/videos/${id}/lock`, { isLocked, unlockCost });

export const deleteVideo = (id) => axiosInstance.delete(`/videos/${id}`);

export const reorderVideos = (ids) =>
  axiosInstance.put('/videos/reorder', { ids });

// ─── PLANS ────────────────────────────────────────────────────────────────────

export const getPlans = () => axiosInstance.get('/videos/plans');

export const getMyPlans = () => axiosInstance.get('/videos/plans/my');